import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  checked: {
    1: true,
    2: true,
    3: true,
    4: true,
    5: true,
    6: true,
  },
};

const projectsSlice = createSlice({
  name: 'projects',
  initialState,
  reducers: {
    toggleCheck: (state, action) => {
      state.checked[action.payload] = !state.checked[action.payload];
    },
  },
});

export const { toggleCheck } = projectsSlice.actions;
export default projectsSlice.reducer;
